<div class="one-whole-adfsweb ml-adfsweb">
    <h2 class="heading-adfsweb">{{'Registered ADFS Webservices'|translate}}</h2>
    <p class="p-adfsweb">{{'Registered ADFS Webservices accessed by ADFS clients'|translate}}
    </p>
    <div class="one-whole-adfsweb">
        <div><input class="btn-adfsweb addadfswebbtn" (click)="addAdfsweb(addadfswebfile)" type="button" value="{{'ADD'|translate}}">
        </div>
        <table class="table__thin tablesorter table">
            <thead class="table__headings">
                <tr>
                    <th class="cid-w-adfsweb">{{'Webservice name'|translate}}</th>
                    <th class="cid-w-adfsweb">{{'Webservice details'|translate}}</th>
                    <th class="cid-w-adfsweb">{{'WSL fallback'|translate}}</th>
                    <th class="cid-w-adfsweb">{{'Webservice details'|translate}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let i of adfswebList;">
                    <td>{{i.name}}</td>
                    <td>{{i.details}}</td>
                    <td *ngIf="i.wslAuthFallback">{{'enabled'|translate}}</td>
                    <td *ngIf="!i.wslAuthFallback">disabled</td>
                    <td class="buttontd-adfsweb">
                        <input class="btn-adfsweb" (click)="editAdfswebdata(i.id,editadfswebCredentials)" type="button"
                            value="{{'EDIT'|translate}}">&nbsp;
                        <input class="btn-adfsweb" (click)="deleteAdfswebdata(i.id,deletePopUpadfsweb)" type="button"
                            value="{{'DELETE'|translate}}">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-dialog modal-lg">
    <ng-template #addadfswebfile let-modal>
        <div class="popup-border-adfsweb">
            <div class="modal-header-adfsweb">
                <span class="header-popup-text-adfsweb">{{'Add new Webservice'|translate}}</span>
                <i class="fa fa-times mng-qualifier-close-btn close-adfsweb-popup"
                    (click)="modal.dismiss('Cross click');clearVariablesadfsweb()" title="close"></i>
            </div>
            <div class="input-box-adfsweb foradd">
                {{'Webservice Name'|translate}}
                <input type="text" class="pop-w-input-adfsweb" name="adfswebnameAdd" [(ngModel)]="adfswebnameAdd">
                <div *ngIf="erroradfswebWebname" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsweb">{{'Webservice Name is missing'|translate}}</span>
                </div>
                <div *ngIf="nameexisterror" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsweb">{{'Webservice name exists already'|translate}}</span>
                </div>
                <div *ngIf="erroradfswebnameLength" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsweb">{{'Webservice name is too long'|translate}}</span>
                </div>
                {{'Webservice Details'|translate}}
                <input type="text" class="pop-w-input-adfsweb" name="adfswebdetailsAdd" [(ngModel)]="adfswebdetailsAdd">
                <div *ngIf="erroradfswebdetails" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsweb">{{'Webservice details are missing'|translate}}</span>
                </div>
                <div *ngIf="erroradfswebdetailsLength" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsweb">{{'Webservice details are too long'|translate}}</span>
                </div>
                <input type="checkbox" name="adfswebwslcheckboxAdd" [(ngModel)]="adfswebwslcheckboxAdd"
                    (change)="adfswebwsladdChecked(adfswebwslcheckboxAdd)">{{'WSL fallback'|translate}}
            </div>
            <div class="modal-footer">
                <input class="input-btn-adfsweb" type="button" value="{{'SUBMIT'|translate}}"
                    (click)="setsubmiteditadfswebAdd(adfswebnameAdd,adfswebdetailsAdd)">
                &nbsp;&nbsp;<input class="input-btn-adfsweb" type="button" value="{{'CLOSE'|translate}}"
                    (click)="modal.close('Close click');clearVariablesadfsweb();">
            </div>
        </div>
    </ng-template>
</div>
<div class="modal-dialog modal-lg">
    <ng-template #editadfswebCredentials let-modal>
        <div class="popup-border-adfsweb">
            <div class="modal-header-adfsweb">
                <span class="header-popup-text-adfsweb">{{'Update Webservice'|translate}}</span>
                <i class="fa fa-times mng-qualifier-close-btn close-adfsweb-popup"
                    (click)="modal.dismiss('Cross click');clearVariablesadfsweb()" title="close"></i>
            </div>
            <div class="input-box-adfsweb">
                <div>{{'Webservice Name'|translate}}</div>
                <input type="text" class="pop-w-input-adfsweb" name="adfswebnameUp" [(ngModel)]="adfswebnameUp"
                    readonly>
                <div *ngIf="!deauthTable">{{'Webservice Details'|translate}}</div>
                <input *ngIf="!deauthTable" type="text" class="pop-w-input-adfsweb" name="adfswebdetailsUp"
                    [(ngModel)]="adfswebdetailsUp">
                <div *ngIf="erroradfswebdetailsup" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsweb">{{'Webservice details are missing'|translate}}</span>
                </div>
                <div *ngIf="erroradfswebdetailsUpLength" class="error-adfs-border">
                    <span class="fa fa-exclamation-triangle"></span>&nbsp;
                    <span class="adderror-adfsweb">{{'Webservice details are too long'|translate}}</span>
                </div>
                <div *ngIf="!deauthTable">
                    <input type="checkbox" name="adfswebwslcheckboxUp" [(ngModel)]="adfswebwslcheckboxUp"
                        (change)="adfswebwsladdCheckedUp(adfswebwslcheckboxUp)">&nbsp;{{'WSL fallback'|translate}}
                </div>
                <div *ngIf="!deauthTable">{{'Authorized ADFS Clients'|translate}}</div>
                <div *ngIf="deauthTable">{{'Registered but unauthorized ADFS Clients'|translate}}</div>
                <table *ngIf="!deauthTable" class="table__thin tablesorter table">
                    <thead class="table__headings">
                        <tr>
                            <th class="adfs_id_web">
                                {{'Client ADFS ID'|translate}}
                            </th>
                            <th class="adfs_deauth_web">
                                {{'Select to Deauthorize client'|translate}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let i of updateListAdfsWebDeauth;">
                            <td>{{i.clientID}}</td>
                            <td>
                                <input type="checkbox" (change)="adfswebdeauthorizecheck(i)">&nbsp;
                                {{'Deauthorize'|translate}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table *ngIf="deauthTable" class="table__thin tablesorter table">
                    <thead class="table__headings">
                        <tr>
                            <th class="adfs_id_web">
                                {{'Client ADFS ID'|translate}}
                            </th>
                            <th class="adfs_deauth_web">
                                {{'Authorize new client'|translate}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let i of updateListAdfsWebAuth;">
                            <td>{{i.clientID}}</td>
                            <td>
                                <input type="checkbox" (change)="adfswebauthorizecheck(i)">&nbsp;
                                {{'Authorize'|translate}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <input *ngIf="!deauthTable" class="input-btn-adfsweb" type="button" value="{{'Authorize new client caps'|translate}}"
                    (click)="authorizeNewClient()">&nbsp;
                <input *ngIf="!deauthTable" class="input-btn-adfsweb" type="button" value="{{'SUBMIT'|translate}}"
                    (click)="setsubmiteditadfswebupdatefirst()">&nbsp;
                <input *ngIf="deauthTable" class="input-btn-adfsweb" type="button" value="{{'SUBMIT'|translate}}"
                    (click)="setsubmiteditadfswebupdatesecond()">
                <input class="input-btn-adfsweb" type="button" value="{{'CLOSE'|translate}}"
                    (click)="modal.close('Close click');clearVariablesadfsweb()">
            </div>
        </div>
    </ng-template>
</div>
<div class="modal-dialog modal-sm">
    <ng-template #deletePopUpadfsweb let-modal>
        <div class="popup-border-adfsweb">
            <div class="modal-header-adfsweb">
                {{'Delete Webservice'|translate}}
                <i class="fa fa-times mng-qualifier-close-btn close-adfsweb-popup"
                    (click)="modal.dismiss('Cross click');clearVariablesadfsweb()" title="close"></i>
            </div>
            <div class="padding-adfsweb">
                <label>{{'Are you sure you want to delete this webservice'|translate}}?</label>
            </div>
            <div class="modal-footer">
                <input class="input-btn-adfsweb" type="button" value="{{'Ok'|translate}}"
                    (click)="modal.dismiss('deletePopUpadfsweb');deletePopcredentialadfsweb();">
                &nbsp;&nbsp;
                <input class="input-btn-adfsweb" type="button" value="{{'CLOSE'|translate}}"
                    (click)="modal.close('Close click');clearVariablesadfsweb()">
            </div>
        </div>
    </ng-template>
</div>
<div *ngIf="isBackToTopShowBtn" (scroll)="onScroll($event)" class="back-to-top-adfsweb" style="display: block;"
    (click)="topFunction()">